import { getOne, updateOne } from 'api/speciesApi';
import PageLockHOC from 'hoc/pageLock';
import Message from 'rc-message';
import React from 'react';
import SpeciesForm from '../SpeciesForm';

@PageLockHOC(['biodiversity.write'])
export default class SpeciesEdit extends React.Component {
  static propTypes = {};

  state = {
    species: {},
  };

  async componentDidMount() {
    const { match } = this.props;
    const speciesID = match.params._id;
    const results = await getOne(speciesID);
    this.setState({ species: results.data });
  }

  handleSubmit = async (values) => {
    const { match, history } = this.props;
    const speciesID = match.params._id;
    const res = await updateOne(speciesID, values);

    if (res.success) {
      Message.success({ content: 'Sửa Thành Công' });
      history.goBack();
    }
    if (res.error) Message.error({ content: res.message });
  };

  render() {
    const { species } = this.state;

    return (
      <SpeciesForm
        isEdit
        initialValue={species}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityView/SpeciesManagement/SpeciesEdit/index.js